import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { RoofType } from '../types';
import { apiService } from './api.service';

class RoofTypesService {
  async getAllRoofTypes(status: string = STATUS_FILTER_VALUES.ALL): Promise<RoofType[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<RoofType[]>(CR_API_ENDPOINTS.ROOF_TYPES, params);
  }

  async getActiveRoofTypes(): Promise<RoofType[]> {
    const params = { [QUERY_PARAMS.STATUS]: STATUS_FILTER_VALUES.ACTIVE };
    return apiService.get<RoofType[]>(CR_API_ENDPOINTS.ROOF_TYPES, params);
  }

  async getRoofTypeById(id: string): Promise<RoofType> {
    return apiService.get<RoofType>(`${CR_API_ENDPOINTS.ROOF_TYPES}/${id}`);
  }

  async createRoofType(roofTypeData: {
    type: string;
  }): Promise<RoofType> {
    try {
      return await apiService.post<RoofType>(CR_API_ENDPOINTS.ROOF_TYPES, roofTypeData);
    } catch (error) {
      throw new Error(`Failed to create roof type: ${error}`);
    }
  }
}

export const roofTypesService = new RoofTypesService();